/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  let currentBundleTotal = 0;

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      const popup = document.querySelector("[data-bundle-threshold-popup]");
      if (!popup) return;

      const thresholdValue = parseInt(
        popup.getAttribute("data-threshold-value"),
        10
      );
      if (!thresholdValue) return;

      const step2Container = document.querySelector("[data-bundle-step='2']");

      if (!step2Container || step2Container.classList.contains("hidden")) {
        popup.classList.add("hidden");
        return;
      }

      const cartTotal = cart.total_price || 0;
      const combinedTotal = currentBundleTotal + cartTotal;

      if (combinedTotal >= thresholdValue) {
        popup.classList.remove("hidden");
      } else {
        popup.classList.add("hidden");
      }
    }
  });

  // Collection Bundle functionality
  (function initCollectionBundle() {
    function getBundleSection(element) {
      return element.closest("[data-bundle-section]");
    }

    async function changeToStep2() {
      // Scroll to top when changing to step 2
      window.scrollTo({ top: 0, behavior: "smooth" });

      const divStep1 = document.querySelector("[data-bundle-step='1']");
      const divStep2 = document.querySelector("[data-bundle-step='2']");
      const step1Text = document.querySelector("[data-bundle-step-1-text]");
      const step2Text = document.querySelector("[data-bundle-step-2-text]");
      if (divStep1 && divStep2) {
        divStep1.classList.add("hidden");
        divStep2.classList.remove("hidden");
        step1Text.style.opacity = 0.5;
        step2Text.style.opacity = 1;
        // Update button states when step changes
        await updateButtonStates();
        // Update price when switching to step 2
        const addToCartStep2Btn = document.querySelector(
          "[data-bundle-add-to-cart-step-2]"
        );
        if (addToCartStep2Btn) {
          await updateStep2ButtonPrice(addToCartStep2Btn, divStep2);
        }
        // Check threshold popup when switching to step 2
        const step2Container = document.querySelector("[data-bundle-step='2']");
        if (step2Container) {
          // Calculate current total to check threshold
          const inputs = step2Container.querySelectorAll(
            "[data-quantity-input][data-variant-id][data-variant-price]"
          );
          const selectElements = step2Container.querySelectorAll(
            "[data-bundle-plan-select][data-product-id][data-variant-id]"
          );
          let total = 0;
          inputs.forEach((input) => {
            const quantity = parseInt(input.value, 10) || 0;
            if (quantity > 0) {
              const variantPrice =
                parseInt(input.getAttribute("data-variant-price"), 10) || 0;
              const select = Array.from(selectElements).find(
                (s) =>
                  s.getAttribute("data-product-id") ===
                    input.getAttribute("data-product-id") &&
                  s.getAttribute("data-variant-id") ===
                    input.getAttribute("data-variant-id")
              );
              let price = variantPrice;
              if (select && select.value) {
                const selectedOption = select.querySelector(
                  `option[value="${select.value}"]`
                );
                if (selectedOption) {
                  const planPrice =
                    selectedOption.getAttribute("data-plan-price");
                  if (planPrice) {
                    price = parseInt(planPrice, 10) || variantPrice;
                  }
                }
              }
              total += price * quantity;
            }
          });
          checkThresholdPopup(total, step2Container);
        }
      }
    }

    async function changeToStep1() {
      // Scroll to top when changing to step 1
      window.scrollTo({ top: 0, behavior: "smooth" });

      const divStep1 = document.querySelector("[data-bundle-step='1']");
      const divStep2 = document.querySelector("[data-bundle-step='2']");
      const step1Text = document.querySelector("[data-bundle-step-1-text]");
      const step2Text = document.querySelector("[data-bundle-step-2-text]");
      if (divStep1 && divStep2) {
        divStep1.classList.remove("hidden");
        divStep2.classList.add("hidden");
        step1Text.style.opacity = 1;
        step2Text.style.opacity = 0.5;
        // Update button states when step changes
        await updateButtonStates();
      }
    }

    function hasSelectedProducts(stepNumber) {
      const section = document.querySelector("[data-bundle-section]");
      if (!section) return false;

      const stepContainer = section.querySelector(
        `[data-bundle-step="${stepNumber}"]`
      );
      if (!stepContainer) return false;

      const inputs = stepContainer.querySelectorAll(
        "[data-quantity-input][data-variant-id]"
      );

      for (const input of inputs) {
        const quantity = parseInt(input.value, 10) || 0;
        if (quantity > 0) {
          return true;
        }
      }

      return false;
    }

    async function updateButtonStates() {
      const section = document.querySelector("[data-bundle-section]");
      if (!section) return;

      // Check step 1
      const step1Container = section.querySelector("[data-bundle-step='1']");
      const step2Container = section.querySelector("[data-bundle-step='2']");

      const nextBtn = section.querySelector("[data-bundle-next]");
      const addToCartStep2Btn = section.querySelector(
        "[data-bundle-add-to-cart-step-2]"
      );

      // Update step 1 button (next)
      if (
        nextBtn &&
        step1Container &&
        !step1Container.classList.contains("hidden")
      ) {
        nextBtn.disabled = !hasSelectedProducts(1);
      }

      // Update step 2 button (add to cart)
      if (
        addToCartStep2Btn &&
        step2Container &&
        !step2Container.classList.contains("hidden")
      ) {
        addToCartStep2Btn.disabled = !hasSelectedProducts(2);
        // Update button with total price
        await updateStep2ButtonPrice(addToCartStep2Btn, step2Container);
      }
    }

    async function updateStep2ButtonPrice(button, step2Container) {
      if (!button || !step2Container) return;

      const inputs = step2Container.querySelectorAll(
        "[data-quantity-input][data-variant-id][data-variant-price]"
      );
      const selectElements = step2Container.querySelectorAll(
        "[data-bundle-plan-select][data-product-id][data-variant-id]"
      );

      let bundleTotal = 0;
      const originalText =
        button.getAttribute("data-original-text") || button.textContent.trim();

      inputs.forEach((input) => {
        const quantity = parseInt(input.value, 10) || 0;
        if (quantity > 0) {
          const variantPrice =
            parseInt(input.getAttribute("data-variant-price"), 10) || 0;

          // Find the corresponding select element for selling plan
          const select = Array.from(selectElements).find(
            (s) =>
              s.getAttribute("data-product-id") ===
                input.getAttribute("data-product-id") &&
              s.getAttribute("data-variant-id") ===
                input.getAttribute("data-variant-id")
          );

          let price = variantPrice;

          // If there's a selling plan selected, use its price
          if (select && select.value) {
            const selectedOption = select.querySelector(
              `option[value="${select.value}"]`
            );
            if (selectedOption) {
              const planPrice = selectedOption.getAttribute("data-plan-price");
              if (planPrice) {
                price = parseInt(planPrice, 10) || variantPrice;
              }
            }
          }

          bundleTotal += price * quantity;
        }
      });

      // Get cart total and add to bundle total
      const cartTotal = await getCartTotal();
      const total = bundleTotal + cartTotal;

      // Format the price using Shopify's money format
      if (total > 0) {
        const formattedPrice = formatMoney(total);
        button.textContent = `${originalText} • ${formattedPrice}`;
      } else {
        button.textContent = originalText;
      }

      currentBundleTotal = bundleTotal;
      // Check threshold and update popup visibility
      checkThresholdPopup(bundleTotal, step2Container);
    }

    async function getCartTotal() {
      try {
        const response = await fetch("/cart.js");
        const cart = await response.json();
        return cart.total_price || 0; // em centavos
      } catch (error) {
        console.error("Error to find the cart:", error);
        return 0;
      }
    }

    async function checkThresholdPopup(total, step2Container) {
      if (!step2Container) return;

      const popup = document.querySelector("[data-bundle-threshold-popup]");
      if (!popup) return;

      const thresholdValue = parseInt(
        popup.getAttribute("data-threshold-value"),
        10
      );
      if (!thresholdValue || isNaN(thresholdValue)) return;

      // Check if we're in step 2 and step 2 is visible
      const step2ContainerVisible =
        step2Container && !step2Container.classList.contains("hidden");

      const cartTotal = await getCartTotal();

      const combinedTotal = total + cartTotal;

      // Show popup if total meets threshold and step 2 is visible
      if (combinedTotal >= thresholdValue && step2ContainerVisible) {
        popup.classList.remove("hidden");
      } else {
        popup.classList.add("hidden");
      }
    }

    function initThresholdPopup() {
      const popup = document.querySelector("[data-bundle-threshold-popup]");
      if (!popup) return;

      const closeButton = popup.querySelector(
        "[data-bundle-threshold-popup-close]"
      );
      if (closeButton) {
        closeButton.addEventListener("click", function (e) {
          e.preventDefault();
          popup.classList.add("hidden");
        });
      }
    }

    function formatMoney(cents) {
      if (
        typeof window.themeCurrency !== "undefined" &&
        window.theme.moneyFormat
      ) {
        return window.themeCurrency.formatMoney(
          cents,
          window.theme.moneyFormat
        );
      }

      if (typeof window.theme !== "undefined" && window.theme.moneyFormat) {
        // Use Shopify's money format
        const format = window.theme.moneyFormat;
        const value = cents / 100;
        // Handle different format types
        if (format.includes("{{amount}}")) {
          return format.replace("{{amount}}", value.toFixed(2));
        } else if (format.includes("amount")) {
          return format.replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2));
        }
      }

      // Fallback formatting
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: window.Shopify?.currency?.active || "USD",
      }).format(cents / 100);
    }

    // Listen for selling plan changes in step 2
    function initPlanSelectors() {
      const step2Container = document.querySelector("[data-bundle-step='2']");
      if (!step2Container) return;

      const planSelectors = step2Container.querySelectorAll(
        "[data-bundle-plan-select]"
      );

      planSelectors.forEach((select) => {
        select.addEventListener("change", async function () {
          const addToCartStep2Btn = document.querySelector(
            "[data-bundle-add-to-cart-step-2]"
          );
          if (
            addToCartStep2Btn &&
            step2Container &&
            !step2Container.classList.contains("hidden")
          ) {
            await updateStep2ButtonPrice(addToCartStep2Btn, step2Container);
          }
        });
      });
    }

    // Initialize quantity selectors directly (similar to theme's approach)
    function initQuantitySelectors(container) {
      const quantityWrappers = container.querySelectorAll(
        "[data-quantity-selector]"
      );

      quantityWrappers.forEach((wrapper) => {
        // Skip if already initialized
        if (wrapper.dataset.bundleInitialized === "true") return;

        const increase = wrapper.querySelector("[data-increase-quantity]");
        const decrease = wrapper.querySelector("[data-decrease-quantity]");
        const input = wrapper.querySelector("[data-quantity-input]");

        if (!increase || !decrease || !input) return;

        // Mark as initialized
        wrapper.dataset.bundleInitialized = "true";

        const min = parseInt(input.getAttribute("min"), 10) || 0;

        // Add event listeners directly to buttons
        increase.addEventListener("click", async function (e) {
          e.preventDefault();
          e.stopPropagation();
          let v = parseInt(input.value, 10);
          v = isNaN(v) ? 0 : v;
          v++;
          input.value = v;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          await updateButtonStates();
        });

        decrease.addEventListener("click", async function (e) {
          e.preventDefault();
          e.stopPropagation();
          let v = parseInt(input.value, 10);
          v = isNaN(v) ? 0 : v;
          v--;
          v = Math.max(min, v);
          input.value = v;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          await updateButtonStates();
        });

        // Listen to input changes (manual typing)
        input.addEventListener("input", async function () {
          await updateButtonStates();
        });
      });
    }

    async function addToCart(button) {
      const section = getBundleSection(button);
      if (!section) return;

      // Get step 1 container to ensure we only get inputs from step 1
      const step1Container = section.querySelector("[data-bundle-step='1']");
      if (!step1Container) return;

      // Get all quantity inputs with variant IDs from step 1 only
      const inputs = step1Container.querySelectorAll(
        "[data-quantity-input][data-variant-id]"
      );
      const itemsToAdd = [];

      // Collect products with quantity > 0
      inputs.forEach((input) => {
        const variantId = input.getAttribute("data-variant-id");
        const sellingPlanId = input.getAttribute("data-selling-plan-id");
        const quantity = parseInt(input.value, 10) || 0;
        if (quantity > 0 && variantId) {
          const item = {
            id: variantId,
            quantity: quantity,
          };
          // Add selling plan if required
          if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
          }
          itemsToAdd.push(item);
        }
      });

      if (itemsToAdd.length === 0) {
        // Button should be disabled, but just in case
        return;
      }

      // Disable button and show loading state
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = "Adding...";

      try {
        // Add all products to cart using items array
        const response = await fetch(`${window.theme.routes.cart}/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: itemsToAdd,
          }),
        });

        if (!response.ok) {
          // Try to parse error as JSON, fallback to text
          let errorMessage = "Failed to add products to cart";
          try {
            const errorData = await response.json();
            errorMessage =
              errorData.message || errorData.description || errorMessage;
          } catch (e) {
            const text = await response.text();
            errorMessage = text.substring(0, 200) || errorMessage;
          }
          throw new Error(errorMessage);
        }

        await changeToStep2();

        // Fetch complete cart data to ensure we have all items
        const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
        if (!cartResponse.ok) {
          throw new Error("Failed to fetch cart data");
        }
        const cartData = await cartResponse.json();

        // Trigger cart update event
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            detail: {
              cart: cartData,
            },
            bubbles: true,
          })
        );

        // Trigger cart reload to update cart drawer immediately
        // Use setTimeout to ensure theme:cart:change is processed first
        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:cart:reload", {
              bubbles: true,
            })
          );
        }, 50);

        // Show popdown notification for the last added product
        if (cartData && cartData.items && cartData.items.length > 0) {
          // Find the last added item (should be one of our items)
          const lastAddedItem = cartData.items[cartData.items.length - 1];

          const variant = {
            id: lastAddedItem.variant_id,
            product: {
              id: lastAddedItem.product_id,
              title: lastAddedItem.product_title,
              has_only_default_variant:
                !lastAddedItem.variant_title ||
                lastAddedItem.variant_title === "Default Title",
            },
            title: lastAddedItem.variant_title || "Default Title",
          };

          // Dispatch popdown event
          const popdown = document.querySelector(
            "[data-product-add-popdown-wrapper]"
          );
          if (popdown) {
            popdown.dispatchEvent(
              new CustomEvent("theme:cart:popdown", {
                detail: {
                  variant: variant,
                },
                bubbles: true,
              })
            );
          }
        }

        // Restore button state after successful addition
        button.disabled = false;
        button.textContent = originalText;
      } catch (error) {
        console.error("Error adding to cart:", error);
        alert("Error adding products to cart: " + error.message);
        button.disabled = false;
        button.textContent = originalText;
      }
    }

    // Initialize micromodal for bundle help
    function initBundleModal() {
      if (typeof window.MicroModal === "undefined") {
        // Wait a bit for MicroModal to load
        setTimeout(initBundleModal, 100);
        return;
      }

      const bundleSection = document.querySelector("[data-bundle-section]");
      if (!bundleSection) return;

      // Find the section ID from data-section-id attribute or from the modal ID
      const sectionId = bundleSection
        .closest("[data-section-id]")
        ?.getAttribute("data-section-id");
      const modal = bundleSection.querySelector('[id^="bundle-help-"]');

      if (modal && sectionId) {
        const modalId = modal.id;
        const triggerAttr = `data-popup-${sectionId}`;

        // Check if already initialized
        if (modal.dataset.micromodalInitialized) return;

        window.MicroModal.init({
          openTrigger: triggerAttr,
          disableScroll: true,
          onShow: (modalEl) => {
            const firstFocus = modalEl.querySelector(
              "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"
            );
            if (firstFocus) {
              firstFocus.focus();
            }
          },
        });

        modal.dataset.micromodalInitialized = "true";
      }
    }

    // Initialize quantity selectors when DOM is ready
    async function init() {
      const bundleSections = document.querySelectorAll("[data-bundle-section]");
      bundleSections.forEach((section) => {
        initQuantitySelectors(section);
      });
      // Initialize plan selectors
      initPlanSelectors();
      // Initialize button states
      await updateButtonStates();
      // Initialize modal
      initBundleModal();
      // Initialize threshold popup
      initThresholdPopup();
    }

    // Initialize on page load
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      // DOM already loaded, initialize immediately
      init();
    }

    async function addToCartStep2(button) {
      const section = getBundleSection(button);
      if (!section) return;

      // Get step 2 container
      const step2Container = section.querySelector("[data-bundle-step='2']");
      if (!step2Container) return;

      // Get all quantity inputs with variant IDs from step 2
      const inputs = step2Container.querySelectorAll(
        "[data-quantity-input][data-variant-id]"
      );
      const itemsToAdd = [];

      // Collect products with quantity > 0 and their selected plans
      inputs.forEach((input) => {
        const variantId = input.getAttribute("data-variant-id");
        const productId = input.getAttribute("data-product-id");
        const quantity = parseInt(input.value, 10) || 0;

        if (quantity > 0 && variantId) {
          // Find the plan selector for this product
          let sellingPlanId = null;
          const planSelector = step2Container.querySelector(
            `[data-bundle-plan-select][data-product-id="${productId}"][data-variant-id="${variantId}"]`
          );

          if (planSelector) {
            const selectedOption =
              planSelector.options[planSelector.selectedIndex];
            // Only use selling plan if a plan is selected (not empty/one-time purchase)
            if (selectedOption && selectedOption.value) {
              sellingPlanId = selectedOption.value;
            }
          }

          const item = {
            id: variantId,
            quantity: quantity,
          };

          // Add selling plan if selected
          if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
          }

          itemsToAdd.push(item);
        }
      });

      if (itemsToAdd.length === 0) {
        // Button should be disabled, but just in case
        return;
      }

      // Disable button and show loading state
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = "Adding...";

      try {
        // Add all products to cart using items array
        const response = await fetch(`${window.theme.routes.cart}/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: itemsToAdd,
          }),
        });

        if (!response.ok) {
          // Try to parse error as JSON, fallback to text
          let errorMessage = "Failed to add products to cart";
          try {
            const errorData = await response.json();
            errorMessage =
              errorData.message || errorData.description || errorMessage;
          } catch (e) {
            const text = await response.text();
            errorMessage = text.substring(0, 200) || errorMessage;
          }
          throw new Error(errorMessage);
        }

        // Fetch complete cart data to ensure we have all items
        const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
        if (!cartResponse.ok) {
          throw new Error("Failed to fetch cart data");
        }
        const cartData = await cartResponse.json();

        // Trigger cart update event
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            detail: {
              cart: cartData,
            },
            bubbles: true,
          })
        );

        // Trigger cart reload to update cart drawer immediately
        // Use setTimeout to ensure theme:cart:change is processed first
        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:cart:reload", {
              bubbles: true,
            })
          );
        }, 50);

        // Show popdown notification for the last added product
        if (cartData && cartData.items && cartData.items.length > 0) {
          // Find the last added item (should be one of our items)
          const lastAddedItem = cartData.items[cartData.items.length - 1];

          const variant = {
            id: lastAddedItem.variant_id,
            product: {
              id: lastAddedItem.product_id,
              title: lastAddedItem.product_title,
              has_only_default_variant:
                !lastAddedItem.variant_title ||
                lastAddedItem.variant_title === "Default Title",
            },
            title: lastAddedItem.variant_title || "Default Title",
          };

          // Dispatch popdown event
          const popdown = document.querySelector(
            "[data-product-add-popdown-wrapper]"
          );
          if (popdown) {
            popdown.dispatchEvent(
              new CustomEvent("theme:cart:popdown", {
                detail: {
                  variant: variant,
                },
                bubbles: true,
              })
            );
          }
        }

        // Restore button state after successful addition
        button.disabled = false;
        button.textContent = originalText;
      } catch (error) {
        console.error("Error adding to cart:", error);
        alert("Error adding products to cart: " + error.message);
        button.disabled = false;
        button.textContent = originalText;
      }
    }

    // Event listener for the "skip" button
    document.addEventListener("click", async function (e) {
      const skipBtn = e.target.closest("[data-bundle-skip]");
      if (skipBtn) {
        e.preventDefault();
        e.stopPropagation();
        await changeToStep2();
      }
    });

    // Event listener for the "next" button
    document.addEventListener("click", function (e) {
      const nextBtn = e.target.closest("[data-bundle-next]");
      if (nextBtn) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(nextBtn);
      }
    });

    // Event listener for step 1 breadcrumb navigation
    document.addEventListener("click", async function (e) {
      const step1Nav = e.target.closest("[data-bundle-step-1-nav]");
      if (step1Nav) {
        e.preventDefault();
        e.stopPropagation();
        await changeToStep1();
      }
    });

    // Event listener for step 2 breadcrumb navigation
    document.addEventListener("click", async function (e) {
      const step2Nav = e.target.closest("[data-bundle-step-2-nav]");
      if (step2Nav) {
        e.preventDefault();
        e.stopPropagation();
        await changeToStep2();
      }
    });

    // Event listener for the "add to cart step 2" button
    document.addEventListener("click", function (e) {
      const addToCartBtn = e.target.closest("[data-bundle-add-to-cart-step-2]");
      if (addToCartBtn) {
        e.preventDefault();
        e.stopPropagation();
        addToCartStep2(addToCartBtn);
      }
    });

    // Bundle filter functionality
    function initBundleFilter() {
      const filterButtons = document.querySelectorAll(
        "[data-bundle-filter] .bundle-filter-btn"
      );
      const productCards = document.querySelectorAll(".bundle-product-card");

      if (filterButtons.length === 0 || productCards.length === 0) return;

      // Initialize active button style on page load
      filterButtons.forEach((btn) => {
        if (btn.classList.contains("active")) {
          btn.style.textDecoration = "underline";
        } else {
          btn.style.textDecoration = "none";
        }
      });

      filterButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Remove active class from all buttons and reset opacity
          filterButtons.forEach((btn) => {
            btn.classList.remove("active");
            btn.style.opacity = "0.7";
            btn.style.textDecoration = "none";
          });

          // Add active class to clicked button and set full opacity
          button.classList.add("active");
          button.style.opacity = "1";
          button.style.textDecoration = "underline";

          // Get filter value
          const filterValue = button.getAttribute("data-filter");

          // Filter products
          productCards.forEach((card) => {
            if (filterValue === "all") {
              card.classList.remove("hidden");
            } else if (filterValue === "model-a") {
              if (card.getAttribute("data-model-a") === "true") {
                card.classList.remove("hidden");
              } else {
                card.classList.add("hidden");
              }
            } else if (filterValue === "model-v") {
              if (card.getAttribute("data-model-v") === "true") {
                card.classList.remove("hidden");
              } else {
                card.classList.add("hidden");
              }
            }
          });
        });
      });
    }

    // Initialize bundle filter
    initBundleFilter();
  })();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
